"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var modal_1 = __importDefault(require("../../../plugins/modal"));
var BundlerUnavailableModal = function (_a) {
    var isOpen = _a.isOpen, message = _a.message;
    return (react_1.default.createElement(modal_1.default, { disableClose: true, isOpen: isOpen, style: { content: { borderRadius: '15px' } } },
        react_1.default.createElement("div", { className: 'padding-vertical-6 padding-horizontal-6 grid-container' },
            react_1.default.createElement("div", null, message),
            react_1.default.createElement("div", { className: 'margin-top-4' }),
            react_1.default.createElement("div", { className: 'text-center' },
                react_1.default.createElement("a", { className: 'button margin-0 padding-vertical-4 text-right light-wisteria', href: '/' }, "Continue browsing")))));
};
exports.default = BundlerUnavailableModal;
